import type { Product } from "~/types/ecom/product/product.type";

export default function getAltFromProductImage(product:Product) {
  if(!product.name) console.warn("could not extract alt text from product as name not found:", product);
  return product.brand
    ? `${product.brand} / ${product.name}`
    : `${product.name}`;
}